import _ from 'lodash';

export async function sendMessageToFirestore(
    chatRoomId,
    senderId,
    firestore,
    text,
    avatar,
    setAction,
    isJobChat,
    senderName,
) {
    try {
        let latestMessage = {};
        const localText = typeof text === 'string' ? text : { ...text };
        if (localText?.text === '' || localText?.text?.length === 0) {
            delete localText.text;
        }
        if (isJobChat) {
            latestMessage = {
                messageType: 'text', senderId, date: new Date(), ...localText,
            };
        } else {
            latestMessage = {
                messageType: 'text', text: localText, senderId, date: new Date(), avatar: avatar || null, senderName: senderName || '',
            };
        }

        const message = await firestore
            .collection(__env.CHAT_ROOMS_COLLECTION)
            .doc(`${chatRoomId}`)
            .collection('messages')
            .add(latestMessage);

        const snapshot = await message.get();

        if (setAction) {
            setAction(snapshot.data());
        }
        return snapshot.data();
    } catch (error) {
        throw Error(error);
    }
}

export async function createPrivateChatRoom(
    participants,
    firestore,
    setMessageAction,
    currentUserId,
    text,
    senderName,
) {
    try {
        const newChatRoomData = participants.reduce(
            (acc, p) => ({
                ...acc,
                [`archived${p}`]: false,
                [`lastSeenDate${p}`]: new Date(),
                isChannel: false,
                isTraining: false,
                chatImage: null,
                created: new Date(),
                updatedAt: Date.now(),
            }),
            { participants, isGroupChat: participants.length > 2 },
        );

        await firestore
            .collection(__env.CHAT_ROOMS_COLLECTION)
            .doc(`${participants[0]}_${participants[1]}`)
            .set(newChatRoomData);

        const latestMessage = await sendMessageToFirestore(`${participants[0]}_${participants[1]}`, currentUserId, firestore, text, null, setMessageAction, false, senderName);

        const querry = await firestore
            .collection(__env.CHAT_ROOMS_COLLECTION)
            .doc(`${participants[0]}_${participants[1]}`)
            .get();

        const newRoom = {
            ...querry.data(), id: querry.id, renderId: `${querry.id}refrshed`, latestMessage,
        };
        return newRoom;
    } catch (error) {
        return error;
    }
}

export async function getOrCreateChatRoom(
    chatRooms,
    participants,
    firestore,
    chatTitle,
    isChannel,
    chatImage,
    jobId,
    staffId,
    senderId,
    text,
    setMessageAction,
    isOfferExist = false,
) {
    try {
        const isJobChat = Boolean(jobId && staffId);
        const filter = (cr) => cr.participants.length === participants.length
      && _.intersection(cr.participants, participants).length === cr.participants.length;

        const jobChatFilter = (cr) => cr.id && cr.id === `${staffId}_${jobId}`;

        const jobChatCreate = async (newChatRoomData) => {
            if (isOfferExist) return null;
            await firestore
                .collection(__env.CHAT_ROOMS_COLLECTION)
                .doc(`${staffId}_${jobId}`)
                .set(newChatRoomData);
            const message = { messageType: 'JobDescription', jobId, text };
            await sendMessageToFirestore(
                `${staffId}_${jobId}`,
                senderId,
                firestore,
                message,
                null,
                setMessageAction,
                true,
            );
            return { ...newChatRoomData, id: `${staffId}_${jobId}` };
        };

        const chatRoom = chatRooms && chatRooms.find((cr) => (isJobChat ? jobChatFilter(cr) : filter(cr)));

        if (!chatRoom) {
            const newChatRoomData = participants.reduce(
                (acc, p) => ({
                    ...acc,
                    [`archived${p}`]: false,
                    [`lastSeenDate${p}`]: new Date(),
                    updatedAt: Date.now(),
                    isTraining: false,
                    isChannel,
                    chatImage,
                    jobId,
                    staffId,
                }),
                { participants, chatTitle, isGroupChat: participants.length > 2 },
            );

            const newChatRoom = isJobChat
                ? await jobChatCreate(newChatRoomData)
                : await firestore.collection(__env.CHAT_ROOMS_COLLECTION).add({ ...newChatRoomData });

            return newChatRoom;
        }

        return chatRoom;
    } catch (error) {
        return error;
    }
}

export const addUserToChat = async ({ jobId, staffId }) => {
    try {
        const response = await fetch('/api/v1/users/add-to-chat', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ jobId, staffId }),
        });
        if (!response.ok) {
            const errorBody = await response.json();
            throw Error(errorBody?.error?.message || response.statusText);
        }
        return await response.json();
    } catch (error) {
        throw Error(error);
    }
};

export const privateChatRoomExists = async (firestore, participants) => {
    try {
        const query = await firestore
            .collection(__env.CHAT_ROOMS_COLLECTION)
            .where('participants', 'in', [participants]);

        const rooms = await query.get();

        let chatRooms = rooms.docs.map((doc) => ({ ...doc.data(), id: doc.id }));

        chatRooms = chatRooms.filter((chat) => !chat?.jobId && chat?.participants?.length <= 2);

        if (chatRooms.length > 0) {
            return chatRooms[0];
        } return false;
    } catch (error) {
        throw Error(error);
    }
};

export const getChatRooms = async ({
    firestore, profileId, archived, jobId,
}) => {
    try {
        let query = firestore
            .collection(__env.CHAT_ROOMS_COLLECTION)
            .where('participants', 'array-contains', profileId)
            .where('isTraining', '==', false)
            .orderBy('updatedAt', 'desc');

        if (jobId) query = query.where('jobId', '==', jobId);

        const querySnapshot = await query.get();

        return querySnapshot.docs
            .map((doc) => ({ ...doc.data(), id: doc.id }))
            .filter((chatRoom) => chatRoom[`archived${profileId}`] === Boolean(archived));
    } catch (error) {
        return error;
    }
};

export const chatRoomRef = (firestore, chatRoomId) => firestore
    .collection(__env.CHAT_ROOMS_COLLECTION)
    .doc(chatRoomId);

export const chatRoomRequired = async (firestore, chatRoomId) => {
    const doc = await firestore
        .collection(__env.CHAT_ROOMS_COLLECTION)
        .doc(chatRoomId);

    const snapshot = await doc.get();
    const result = snapshot.data()
  result["id"] = chatRoomId;
    result.chatTitle = result.latestMessage.senderName;
    return result;
}

export const messagesNotificationsRefresh = async (firestore, chatRoomId, currentUserId) => {
    const chatRoom = await chatRoomRef(firestore, chatRoomId);
    await chatRoom.update({ [`lastSeenDate${currentUserId}`]: new Date() });
};

export const getMessages = async (
    firestore,
    initialMessageId,
    filterDate,
    chatRoomId,
    start = 0,
) => {
    const msgRef = firestore
        .collection(__env.CHAT_ROOMS_COLLECTION)
        .doc(chatRoomId)
        .collection('messages');

    const limit = initialMessageId ? undefined : 50;

    let querySnapshot = await msgRef.orderBy('date', 'desc');

    if (filterDate) {
      querySnapshot = querySnapshot.where('date', '<=', filterDate);
    }

    if (start) {
      querySnapshot = querySnapshot.startAfter(start);
    }

    if (initialMessageId) {
      querySnapshot = querySnapshot.endAt(await msgRef.doc(initialMessageId).get());
    }

    querySnapshot = querySnapshot.limit(limit);

    const snapshots = await querySnapshot.get();

    const chatMessages = snapshots.docs.map((doc) => ({ ...doc.data(), id: doc.id }));

    return _.orderBy(chatMessages, 'latestMessage.date.seconds', 'desc');
};

export const getUnreadMessagesCounter = async (firebase, profileId, actionSet) => {
    const profile = await firebase
        .collection('userProfile')
        .doc(profileId)
        .get();

    actionSet(profile.data()?.unreadMessagesCounter);
};

export const subscribeChatRoomsPreview = async (
    db,
    profileId,
    setAction,
) => {
    const doc = await db
        .collection(__env.CHAT_ROOMS_COLLECTION)
        .where('participants', 'array-contains', profileId);

    await doc.onSnapshot((querySnapshot) => {
        querySnapshot.docChanges().forEach(async (change) => {
            if (change.type === 'modified') {
                await setAction({
                    ...change.doc.data(), id: change.doc?.id, positionChanged: false, profileId,
                });
            }
        });
    });
};

export const unsubscribeChatRoomsPreview = async (
    db,
    profileId,
) => {
    const doc = await db
        .collection(__env.CHAT_ROOMS_COLLECTION)
        .where('participants', 'array-contains', profileId);

    await doc.onSnapshot((querySnapshot) => {
        querySnapshot.docChanges();
    });
};

export const subscribeChatRoom = async (db, chatRoomId, setAction) => {
    const doc = await db
        .collection(__env.CHAT_ROOMS_COLLECTION)
        .doc(chatRoomId)
        .collection('messages');

    await doc.onSnapshot((querySnapshot) => {
        querySnapshot.docChanges().forEach((change) => {
            if (change.type === 'added') {
                setAction(change.doc.data());
              }
              if (change.type === 'modified') {
                setAction(change.doc.data());
              }
        });
    });
};

export const unSubscribeChatRoom = async (db, chatRoomId) => {
    const doc = db
        .collection(__env.CHAT_ROOMS_COLLECTION)
        .doc(chatRoomId)
        .collection('messages');

    await doc.onSnapshot((querySnapshot) => {
        querySnapshot.docChanges();
    });
};

export const subscribeNotifications = async (firebase, profileId, setAction) => {
    const doc = await firebase
        .collection('userProfile')
        .doc(profileId);

    await doc.onSnapshot((docSnapshot) => {
        const notifs = docSnapshot.data();
        setAction(notifs?.unreadMessagesCounter);
    });
};

export const unSubscribeNotifications = async (firebase, profileId) => {
    const doc = await firebase
        .collection('userProfile')
        .doc(profileId);

    await doc.onSnapshot(() => {
    });
};

export async function createNewNotificationRequestMessageInFirestore(
    firestore,
    chatRoomId,
    senderId,
    message,
    senderName,
    recepientIds,
) {
    try {
        const currentDate = new Date();
        const notificationRequestMessage = {
            message: message,
            senderId: senderId,
            senderName: senderName,
            requestedTime: currentDate.getTime(),
            chatRoomId: chatRoomId,
            recepientIds: recepientIds,
        };
        await firestore.collection(__env.NOTIFICATION_REQ_COLLECTION).add(notificationRequestMessage);
    } catch (error) {
        throw Error(error);
    }
}